import { render, staticRenderFns } from "./JgBespokeBoom.vue?vue&type=template&id=58eee2ea&scoped=true&"
import script from "./JgBespokeBoom.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeBoom.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeBoom.vue?vue&type=style&index=0&id=58eee2ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58eee2ea",
  null
  
)

export default component.exports